<template>
	<el-dialog
    :title="dioTit"
    :visible.sync="pinVisibility"
    :modal-append-to-body="false"
    :show-close='false'
    class="editCardDio pin_dio"
    :close-on-click-modal='false'
    width="840px"
    center
    >
        <div>
            <!-- <div class="tag_tit">oldPIN</div> -->
            <el-input type="password" v-if="opeationStep === 1" v-model="oldPIN" maxlength="16" class="borderNone ssssaaa"></el-input>
            <el-input type="password" v-else v-model="newPIN" maxlength="16" class="borderNone ssss"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel" class="cardCanBtn">Cancel</el-button>
            <el-button @click="confirmPin" class="cardConBtn" :disabled='!oldPIN' v-if="pinType==1">Confirm</el-button>
            <el-button @click="confirm" class="cardConBtn" :disabled='!oldPIN' v-else>{{opeationStep===1?'Next':'Save'}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import api from '../../api/login'
import dashboard from '@/api/dashboard'
import md5 from 'js-md5'

export default {
    props:['pinVisibility','pinType'],
    data () {
        return {
            opeationStep:1,
            oldPIN:'',
            newPIN:'',
            dioTit:'Please enter your old PIN'
        }
    },
    methods: {
        cancel(){
            this.oldPIN = ''
            this.newPIN = ''
            this.dioTit = 'Please enter your old PIN'
            this.$emit('closeDiolog')
        },
        confirm(){ // 修改pin
            const pin = sessionStorage.getItem('pin');
            if(this.opeationStep === 1){ // 确认旧密码
                if (this.oldPIN.length < 4) {
                    Utils.alert2('','Please enter 4-16 digits','error')
                    return
                }
                if (pin === md5(this.oldPIN)) {
                    this.opeationStep = 2
                    this.dioTit = 'Set your new PIN'
                } else {
                    Utils.alert2('','Pin code error','error')
                }
            }else if(this.opeationStep === 2){ // 更新新密码
                if (this.newPIN.length < 4) {
                    Utils.alert2('','Please enter 4-16 digits','error')
                    return
                }
                api.pinUpdate({
                    params: {
                        newPin: this.newPIN,
                        oldPin: pin
                    },
                    callback: (res) => {
                        let {code , message ,data} = res.data
                        if(code==0){
                            window.sessionStorage.setItem('pin',md5(this.newPIN))
                            this.cancel()      
                            Utils.alert2('','Pin code successfully changed', 'success')

                        }else{
                            Utils.alert2('',message,'error')
                        }
                    }
                })
            }
        },
        confirmPin(){ // 验证pin
            // const pin = sessionStorage.getItem('pin');
            // if(pin === md5(this.oldPIN)){
            //     this.$emit('confirmPin',true);
            // }else{ // 不通过
            //     Utils.alert('','Pin code error','error')
            // }
            if (this.oldPIN.length < 4) {
                Utils.alert('','Please enter 4-16 digits','error')
                return
            }
            const pinCode = this.oldPIN
            dashboard.pinAdd({
                params: pinCode,
                callback: (res) => {

                    let {code , message ,data} = res.data
                    if(code==0){
                        window.sessionStorage.setItem('pin', md5(pinCode))
                        window.sessionStorage.setItem('pinstatus', true)
                        this.cancel()              
                        this.$emit('confirmPin',true);
                        Utils.alert2('','Pin code successfully changed', 'success')
                    }else{
                        Utils.alert('',message,'error')
                    }
                }
            })
        }
    },
    mounted() {
        this.dioTit = this.pinType == 1?'Please enter PIN':'Please enter your old PIN'
        
    },
}
</script>

<style lang="scss">
	.tag_tit{
		height:16px;
		font-size:14px;
		font-weight:400;
		color:var(--text-color);
		line-height:16px;
		margin: 30px 0 10px 0;
	}
    .dateMsgBox{
        display: flex;
        .dateFather_box{
            flex: 1;
            .el-input__DateIcon{
                font-size: 22px;
                line-height: 40px;
                margin-left: 15px;
            }
        }
    }
    .checkBox_list{
        display: flex;
        height: 40px;
        align-items: center;
    }
    .venue_checkBox{
        display: flex;
        align-items: center;
        margin-right: 319px;
        .venue_check{
            width:16px;
            height:16px;
            box-sizing: border-box;
            background:rgba(43,52,68,1);
            border-radius:50%;
            border:1px solid rgba(95,95,95,1);
            margin-right: 10px;
            cursor: pointer;
        }
        .venue_checked{
            width:16px;
            height:16px;
            background: url("../../../static/img/Shape.png");
            background-size: cover;
            border-radius:50%;
            background-repeat: no-repeat;
            margin-right: 10px;
            cursor: pointer;
        }
        .venueCheckBox_msg{
            width: 100px;
            height:28px;
            font-size:20px;
            font-family:PingFang SC;
            font-weight:400;
            color:var(--text-color);
            line-height:28px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/pinDiolog.vue